var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 212.154,
    height: 25.36,
    viewBox: "0 0 212.154 25.36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_54",
    "data-name": "Rechteck 54",
    width: 212.154,
    height: 25.36,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_88",
    "data-name": "Gruppe 88",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_147",
    "data-name": "Pfad 147",
    d: "M73.908,25.128H67.815L66.042,20H57.1l-1.735,5.128H49.269l8.56-24.1H65.5ZM61.607,5.773l-3.2,9.445h6.285Z",
    transform: "translate(-20.039 -0.418)",
    fill: "#038eb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_87",
    "data-name": "Gruppe 87",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_86",
    "data-name": "Gruppe 86",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_148",
    "data-name": "Pfad 148",
    d: "M105.905,18.012c0-1.62-1.735-2.16-4.935-3.047-3.508-.963-7.749-2.584-7.749-7.4,0-4.472,3.277-7.44,9.253-7.44A18.355,18.355,0,0,1,111.5,2.241l-1.2,5.051a17.918,17.918,0,0,0-7.787-2.12c-2.12,0-3.163.733-3.163,2.044,0,1.58,2.2,2.2,5.09,3.007,3.7,1,7.557,2.7,7.557,7.287s-3.548,7.827-9.871,7.827a19.785,19.785,0,0,1-9.293-2.2l1.157-5.089a17.9,17.9,0,0,0,8.252,2.237c2.158,0,3.662-.81,3.662-2.275",
    transform: "translate(-37.758 -0.05)",
    fill: "#038eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_149",
    "data-name": "Pfad 149",
    d: "M141.851,15.991v9.138h-6.015V15.952l-8.4-14.922h6.516l4.973,9.524,4.821-9.524h6.477Z",
    transform: "translate(-51.829 -0.419)",
    fill: "#038eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_150",
    "data-name": "Pfad 150",
    d: "M188.213,18.419c0,3.932-2.584,6.709-8.676,6.709H171.71V1.029h7.519c5.783,0,8.211,2.623,8.211,6.285,0,2.352-1.425,4.666-4.626,5.475,3.548.694,5.4,2.815,5.4,5.629M179.344,3.266h-5.166v8.676h4.782c3.624,0,6.013-1.58,6.013-4.434,0-2.584-1.811-4.241-5.629-4.241m-.231,10.911h-4.935v8.713h5.552c4.241,0,6.015-1.734,6.015-4.472,0-2.815-2.353-4.241-6.632-4.241",
    transform: "translate(-69.838 -0.419)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_151",
    "data-name": "Pfad 151",
    d: "M217.164,25.286c-6.709,0-11.838-5.049-11.838-12.492C205.326,5.431,210.3.186,217.2.186c6.709,0,11.836,5.012,11.836,12.454,0,7.364-4.973,12.646-11.875,12.646m-.038-22.9c-5.4,0-9.293,4.165-9.293,10.257,0,6.207,3.972,10.448,9.447,10.448,5.359,0,9.254-4.2,9.254-10.295,0-6.206-3.934-10.41-9.408-10.41",
    transform: "translate(-83.511 -0.076)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_152",
    "data-name": "Pfad 152",
    d: "M270.037,25.128H267.53l-2.545-6.9H254.074l-2.545,6.9h-2.507l9.139-24.1h2.892ZM259.55,3.459,254.924,15.99h9.214Z",
    transform: "translate(-101.283 -0.419)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_153",
    "data-name": "Pfad 153",
    d: "M293.1,25.128h-2.467V1.029h6.478c5.937,0,8.751,2.738,8.751,6.941,0,3.625-2.467,5.822-5.59,6.787l6.67,10.371h-2.854l-6.169-9.947-4.819.308Zm4.318-11.991c3.2-.116,5.976-1.89,5.976-5.051s-2.352-4.819-6.554-4.819H293.1V13.29Z",
    transform: "translate(-118.208 -0.419)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_154",
    "data-name": "Pfad 154",
    d: "M331.4,25.128h-6.362V1.029h6.555c7.9,0,12.762,4.782,12.762,11.877,0,7.6-4.742,12.222-12.955,12.222m.038-21.823H327.5V22.853h4.009c6.169,0,10.373-3.162,10.373-9.754,0-6.132-3.856-9.794-10.45-9.794",
    transform: "translate(-132.199 -0.419)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_155",
    "data-name": "Pfad 155",
    d: "M17.035,8.756l9.775.487L10.718,9.35,0,8.878Z",
    transform: "translate(0 -3.561)",
    fill: "#032630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_156",
    "data-name": "Pfad 156",
    d: "M17.035,0V5.195L0,5.317V.206Z",
    transform: "translate(0 0)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_157",
    "data-name": "Pfad 157",
    d: "M28.714,0l9.775.825V5.682l-9.775-.487Z",
    transform: "translate(-11.679 0)",
    fill: "#038eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_158",
    "data-name": "Pfad 158",
    d: "M17.035,33.905V39.1L0,38.894v-5.11Z",
    transform: "translate(0 -13.74)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_159",
    "data-name": "Pfad 159",
    d: "M28.714,33.655l9.775-.487v4.857l-9.775.825Z",
    transform: "translate(-11.679 -13.49)",
    fill: "#038eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_160",
    "data-name": "Pfad 160",
    d: "M0,33.46l10.718-.472,16.093.107-9.775.487Z",
    transform: "translate(0 -13.417)",
    fill: "#032630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_161",
    "data-name": "Pfad 161",
    d: "M17.035,16.995v5.195L0,22.147v-5.11Z",
    transform: "translate(0 -6.912)",
    fill: "#024050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_162",
    "data-name": "Pfad 162",
    d: "M28.714,16.995l9.775.169V22.02l-9.775.169Z",
    transform: "translate(-11.679 -6.912)",
    fill: "#038eb1"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.fd4ef81b8ab98ae35246002b7a8378b1.svg";